import { shared } from '@shared/_lang/ru';
import { autoinformer } from '@autoinformer/_lang/ru';
import { autocaller_v2 } from '@autocaller_v2/_lang/ru';
import { predictive_connect } from '@predictive_connect/_lang/ru';
import { call_tracking } from '@call-tracking/_lang/ru';
import { core } from '@core/_lang/ru';
import { prices } from '@prices/_lang/ru';
import { db } from '@db/_lang/ru';
import { integration } from '@integration/_lang/ru';
import { mailer } from '@mailer/_lang/ru';
import { notify } from '@notify/_lang/ru';
import { payment } from '@payment/_lang/ru';
import { pbx } from '@pbx/_lang/ru';
import { phone_number } from '@phone-number/_lang/ru';
import { referral } from '@referral/_lang/ru';
import { verification } from '@verification/_lang/ru';
import { voice } from '@voice/_lang/ru';
import { amoWidget } from '@amo-widget/_lang/ru';
import { integrations } from '@integrations/_lang/ru';
import { hlr } from '@hlr/_lang/ru';

import { validator } from '@shared/_lang/ru/validator';

export default {
  shared,
  autoinformer,
  autocaller_v2,
  predictive_connect,
  core,
  prices,
  db,
  integration,
  mailer,
  notify,
  payment,
  pbx,
  referral,
  verification,
  voice,
  validator,
  amoWidget,
  integrations,
  hlr,
  'call-tracking': call_tracking,
  'phone-number': phone_number
};
